import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import TalkService from '../services/TalkService';
import couterpart from 'counterpart';

export default class ReplyDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = { modal: false,msg: '',msgTo :'', parentId: 0};
    this.toggle = this.toggle.bind(this);
    this.handleChangeMsg = this.handleChangeMsg.bind(this);
  }

  toggle(talk) {
    if (talk === undefined) {
      this.setState({
        modal: !this.state.modal
      })
      return
    }
    this.setState({
      msgOfReply: talk.msg,
      modal: !this.state.modal,
      msgTo: talk.createdBy,
      workOrderId: talk.workOrderId,
      parentId: talk.id,
      createdBy: talk.msgTo
    });
  }
  
  handleChangeMsg(event) {
    this.setState({msg: event.target.value});
  }

  handleChangeStatus(e) {
    // var newValue = e.target.checked? 1 : 0;
    if (e.target.checked) {
      this.setState({status: 3}); //Closed
    } else {
      this.setState({status: -1}); //Keep as current
    }
  }

  cancelReply () {
    this.toggle()
    this.props.reloadTalks()
  }

  sendMsg(){
    let vm = this;
    if ((this.state.msg === undefined) || 
      (this.state.msg ===null) || 
      (this.state.msg.length < 1)){
        alert(couterpart.translate('talk_msg_missing'));
        return;
    }
    console.log('SAVED TALK', vm.state);

    TalkService.save(this.state).then(data => {
      alert(couterpart.translate("msg_created_ok"));
      vm.setState({
        modal: false
      });
      vm.props.reloadTalks()
    });
  }

  render() {
    return (

        <div>
        <Modal isOpen={this.state.modal}>
        <form onSubmit={this.handleSubmit}>
          <ModalHeader>Trả lời</ModalHeader>
          <ModalBody>
            
            <div className="row">
              <div className="form-group col-md-12">
                <label>Nội dung: { this.state.msgOfReply }</label>
              </div>
            </div>
            <div className="row">
              <div className="form-group col-md-12">
                <label>Trao đổi:</label>
                <input type="text" value={this.state.msg} onChange={this.handleChangeMsg.bind(this)} className="form-control"/>
              </div>
            </div>
            <div className="row">
              <div className="col-md-2">
                <input type="checkbox" value="3" onChange={this.handleChangeStatus.bind(this)}  className="form-control-s"/>
              </div>
              <div className="col-md-10">
                <label>Đóng trao đổi: { this.state.status }</label>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" className="btn btn-primary" onClick={ this.sendMsg.bind(this) }>Gửi đi</Button>
            <Button color="danger" onClick={ this.cancelReply.bind(this) } className="btn btn-primary">Hủy bỏ</Button>
          </ModalFooter>
          </form>
          </Modal>
        </div>
      
    );
  }
}